export const focusedOtherRollupAriaLabel = "QOeL1b";
export const prioritizeRollupLabel = "tF$fL";
export default {focusedOtherRollupAriaLabel,prioritizeRollupLabel};